// extracted by mini-css-extract-plugin
module.exports = {"NumericOptionalRangeFeature":"or_a vh_b vh_se"};